import { Button, FormGroup, Input, Label, Select } from '@/components'
import { FlexWrapper } from '@/components/layout/flex/flexWrapper'
import { useAxios } from '@/context/axiosContext'
import { useRedis } from '@/hooks/useRedis'
import commonUtils from '@/utils/commonUtils'
import { useEffect, useState } from 'react'
import DataTable, { TableColumn } from 'react-data-table-component'
import { useLocation, useNavigate } from 'react-router-dom'
import { tableStyles } from '@/styles/dataTable/style'
import { marginBottom } from 'styled-system'
type TInput = HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement

interface DataRow {
  nttSn: number
  nttSj: string
  fdbkType: string
  bizNm: string
  rndDt: string
  adminYn: string
  useYn: string
  openYn: string
  regId: string
  updId: string
  regDate: string
  updDate: string
}

interface SrchData {
  srchOpt: string
  srchStr: string
  rndDt: string
  fdbkType: string
  useYn: string
}

const FeedbackMgmt: React.FC = () => {
  const axios = useAxios()
  const navigate = useNavigate()
  const location = useLocation()
  const [data, setData] = useState<DataRow[]>([])
  const { getComCodes, getComCodeValue } = useRedis()

  const [srchData, setSrchData] = useState<SrchData>(
    location.state?.srchData || {
      srchOpt: '',
      srchStr: '',
      rndDt: '',
      fdbkType: '',
      useYn: '',
    },
  )

  const [currentPage, setCurrentPage] = useState(location.state?.page || 1)
  const [perPage, setPerPage] = useState(location.state?.perPage || 10)

  const formatDateString = (dateString?: string): string => {
    if (!dateString || dateString.length !== 8) return ''

    const year = dateString.substring(0, 4)
    const month = dateString.substring(4, 6)
    const day = dateString.substring(6, 8)

    return `${year}.${month}.${day}`
  }

  const columns: TableColumn<DataRow>[] = [
    {
      name: 'No.',
      selector: (row) => row.nttSn,
      sortable: true,
      wrap: true,
      width: '5%',
      cell: (row) => (
        <div style={{ width: '100%', textAlign: 'right' }}>{row.nttSn}</div>
      ),
    },
    {
      name: '종류',
      cell: (row) => getComCodeValue('FDBK_TYPE', row.fdbkType)?.codeNm,
      selector: (row) => row.openYn,
      sortable: true,
      center: true,
      wrap: true,
      width: '5%',
      conditionalCellStyles: [
        {
          when: (row: DataRow) => row.fdbkType === '01',
          style: {
            color: '#4caf50',
          },
        },
        {
          when: (row: DataRow) => row.fdbkType === '02',
          style: {
            color: '#ef5350',
          },
        },
      ],
    },
    {
      name: '골프장명',
      selector: (row) => row.bizNm,
      sortable: true,
      center: true,
      width: '10%',
    },
    {
      name: '라운드날짜',
      selector: (row) => formatDateString(row.rndDt),
      sortable: true,
      center: true,
      wrap: true,
      width: '10%',
    },
    {
      name: '제목',
      selector: (row) => row.nttSj,
      sortable: true,
      width: '20%',
    },
    {
      name: '사용여부',
      cell: (row) => getComCodeValue('USE_YN', row.useYn)?.codeNm,
      selector: (row) => row.useYn,
      sortable: true,
      center: true,
      wrap: true,
      width: '5%',
      conditionalCellStyles: [
        {
          when: (row: DataRow) => row.useYn === 'Y',
          style: {
            color: 'red',
          },
        },
      ],
    },
    {
      name: '수정자',
      selector: (row) => row.updId,
      sortable: true,
      center: true,
      wrap: true,
      width: '10%',
    },
    {
      name: '수정일',
      selector: (row) => row.updDate,
      format: (row) => commonUtils.formatDate(row.updDate, false),
      sortable: true,
      wrap: true,
      width: '10%',
    },

    {
      name: '',
      cell: (row) => (
        <>
          <Button
            variant="outlined"
            color="neverbe"
            size="xs"
            onClick={() => handleButtonUpdateClick(row.nttSn)}
          >
            수정
          </Button>
        </>
      ),
      width: '20%',
      sortable: false,
    },
  ]

  useEffect(() => {
    getFeedbackList()
  }, [])

  // const handleSearch = (e: React.ChangeEvent<TInput>) => {
  //   const { name, value } = e.target as HTMLInputElement | HTMLTextAreaElement // 타입 캐스팅
  //   setSrchData((prev: any) => ({ ...prev, [name]: value }))
  // }

  const handleSearch = (e: React.ChangeEvent<TInput>) => {
    const { name, value } = e.target

    setSrchData((prev) => ({
      ...prev,
      [name]: value,
      ...(name === 'srchOpt' && value !== 'rndDt' ? { rndDt: '' } : {}),
      ...(name === 'srchOpt' && value === 'rndDt' ? { srchStr: '' } : {}),
    }))
  }

  const handleButtonUpdateClick = async (nttSn: number) => {
    navigate(`/feedbackMgmt/detail`, {
      state: {
        nttSn: nttSn,
        srchData: srchData,
        page: currentPage,
        perPage: perPage,
      },
    })
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      getFeedbackList()
    }
  }

  const getFeedbackList = async () => {
    try {
      // 값이 있는 경우만 필터링
      const params = Object.fromEntries(
        Object.entries(srchData).filter(
          ([_, value]) => typeof value === 'string' && value.trim(),
        ),
      )

      const response = await axios.get('/feedbackMgmt/list', {
        params,
      })

      const common = response.data.common
      const data = response.data.data
      let listData = undefined
      if (common.resultCode == 'FEEDBACKS0200') {
        listData = data.feedbackList
      }

      console.log('feedbackList', listData)
      if (Array.isArray(listData)) {
        setData(listData)
      }
    } catch (error) {
      console.error('Error fetching term list:', error)
    }
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          marginBottom: '10px',
          alignItems: 'center',
          marginTop: '50px',
        }}
      >
        <p style={{ marginLeft: '20px', fontSize: '20px' }}>
          목소리게시판 관리
        </p>
        <div
          style={{
            marginLeft: 'auto',
            display: 'felx',
            justifyContent: 'center',
          }}
        >
          <div style={{ display: 'flex', gap: '5px' }}>
            <FormGroup>
              <Label htmlFor={'fdbkType'}>글종류</Label>
              <div style={{ marginBottom: '5px' }} />
              <Select
                id="fdbkType"
                name="fdbkType"
                width="100px"
                onChange={handleSearch}
                value={srchData.fdbkType}
              >
                <option value="">전체</option>
                {getComCodes('FDBK_TYPE').map((item) => (
                  <option key={'fdbkType' + item.code} value={item.code}>
                    {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>
            <FormGroup>
              <Label htmlFor={'useYn'}>사용여부</Label>
              <div style={{ marginBottom: '5px' }} />
              <Select
                id="useYn"
                name="useYn"
                width="100px"
                onChange={handleSearch}
                value={srchData.useYn}
              >
                <option value="">전체</option>
                {getComCodes('USE_YN').map((item) => (
                  <option key={'useYn' + item.code} value={item.code}>
                    {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>
            <FormGroup>
              <Label htmlFor={'srchOpt'}>검색옵션</Label>
              <div style={{ marginBottom: '5px' }} />
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                }}
              >
                <Select
                  id="srchOpt"
                  name="srchOpt"
                  width="100px"
                  onChange={handleSearch}
                  value={srchData.srchOpt}
                >
                  <option value="">전체</option>
                  <option value="nttSj">제목</option>
                  <option value="nttCn">내용</option>
                  <option value="bizNm">골프장명</option>
                </Select>
                {srchData.srchOpt === 'rndDt' && (
                  <Input
                    type="date"
                    id="rndDt"
                    name="rndDt"
                    value={srchData.rndDt}
                    onChange={handleSearch}
                  />
                )}
              </div>
            </FormGroup>
            <FormGroup>
              <Label htmlFor={'rndDt'}>라운드날짜</Label>
              <div style={{ marginBottom: '5px' }} />
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                }}
              >
                <Input
                  type="date"
                  id="rndDt"
                  name="rndDt"
                  value={srchData.rndDt}
                  onChange={handleSearch}
                />
              </div>
            </FormGroup>
            <FormGroup>
              <Label htmlFor={'srchStr'}>
                <></>
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <FlexWrapper>
                <Input
                  placeholder="검색어"
                  width="300px"
                  id="srchStr"
                  name="srchStr"
                  value={srchData.srchStr}
                  onChange={handleSearch}
                  onKeyDown={handleKeyDown}
                />
              </FlexWrapper>
            </FormGroup>
            <FormGroup>
              <Label htmlFor={''}>
                <></>
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <FlexWrapper gap="10px">
                <Button
                  onClick={getFeedbackList}
                  color="neverbe"
                  variant="outlined"
                >
                  검색
                </Button>
              </FlexWrapper>
            </FormGroup>
          </div>
          <div style={{ color: 'red', marginTop: '5px', textAlign: 'right' }}>
            * 옵션 선택 후 검색어 없이 조회 가능
          </div>
        </div>
      </div>
      <DataTable
        // TODO 페이징처리는 서버 vs 클라이언트 (현행 클라이언트)
        columns={columns}
        data={data}
        customStyles={tableStyles}
        paginationDefaultPage={currentPage}
        onChangePage={(page) => setCurrentPage(page)}
        pagination={true}
        paginationPerPage={perPage}
        onChangeRowsPerPage={(page) => setPerPage(page)}
        paginationRowsPerPageOptions={[10, 20, 30, 50, 100, 500]}
        noDataComponent={<>조회결과가 없습니다.</>}
      />
    </>
  )
}
export default FeedbackMgmt
